import { createUseStyles } from 'react-jss';

import colors from "../../../../utils/colors";






var styles = {
  marketingCell: function marketingCell(_ref) {var columnsAmount = _ref.columnsAmount,showWideColumns = _ref.showWideColumns;return {
      width: showWideColumns ? "".concat(40 * columnsAmount, "rem") : "".concat(34 * columnsAmount, "rem"),
      border: "0.1rem solid ".concat(colors.neutral[300]),
      borderRight: "0.1rem solid ".concat(colors.neutral[600]),
      borderLeft: 'none',
      padding: '1rem',
      '&:last-child': {
        borderRight: 'none'
      }
    };},
  tagsList: {
    justifyContent: 'flex-start',
    marginLeft: '1.5rem',
    gap: '2rem',
    '& p': {
      margin: 0
    }
  }
};

var createStyles = createUseStyles(styles);
export { createStyles };
//# sourceMappingURL=styles.js.map